import Home from "./pages/home/Home";
import Login from "./pages/login/Login";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./style/dark.scss";
import "./App.scss";
import { useContext } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import ProtectedRoute from "./ProtectedRoute";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Library from "./pages/library/library";
import EditBook from "./pages/editBook/editBook";
import AddNewBook from "./pages/addNewBook/addNewBook"
import SingleBook from "./pages/singleBook/singleBook";
import SingleBookPending from "./pages/singleBookPending/singleBookPending";
import NotFound from "./NotFound"
import PendingBooks from "./pages/pendingBooks/pendingBooks";
import MyAccount from "./pages/myAccount/myAccount"

const theme = createTheme({
  typography: {
    fontFamily: 'Rubik, sans-serif', // Add your font here
  },
});

function App() {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <ThemeProvider theme={theme}>
      <div className={darkMode ? "app dark" : "app"}>
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<NotFound />} />
            <Route path="/">
              <Route path="login" element={<Login />} />
              <Route
                index
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />
              <Route
                path="add-book"
                element={
                  <ProtectedRoute>
                    <AddNewBook />
                  </ProtectedRoute>
                }
              />
              <Route
                path="account"
                element={
                  <ProtectedRoute>
                    <MyAccount />
                  </ProtectedRoute>
                }
              />

              <Route path="pending-books">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <PendingBooks />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path=":productId"
                  element={
                    <ProtectedRoute>
                      <SingleBookPending />
                    </ProtectedRoute>
                  }
                />

              </Route>
              <Route path="library">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <Library />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path=":productId"
                  element={
                    <ProtectedRoute>
                      <SingleBook />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path=":productId/edit"
                  element={
                    <ProtectedRoute>
                      <EditBook />
                    </ProtectedRoute>
                  }
                />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
